/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BulkTrackResponseDto interface.
 */
export function instanceOfBulkTrackResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('artist' in value) || value['artist'] === undefined)
        return false;
    if (!('album' in value) || value['album'] === undefined)
        return false;
    if (!('albumCover' in value) || value['albumCover'] === undefined)
        return false;
    if (!('bpm' in value) || value['bpm'] === undefined)
        return false;
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('popularity' in value) || value['popularity'] === undefined)
        return false;
    if (!('energy' in value) || value['energy'] === undefined)
        return false;
    if (!('danceability' in value) || value['danceability'] === undefined)
        return false;
    if (!('valence' in value) || value['valence'] === undefined)
        return false;
    if ((!('previewUrl' in value) && !('preview_url' in value)) || (value['previewUrl'] === undefined && value['preview_url'] === undefined))
        return false;
    return true;
}
export function BulkTrackResponseDtoFromJSON(json) {
    return BulkTrackResponseDtoFromJSONTyped(json, false);
}
export function BulkTrackResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'artist': json['artist'],
        'album': json['album'],
        'albumCover': json['albumCover'],
        'bpm': json['bpm'],
        'key': json['key'],
        'popularity': json['popularity'],
        'energy': json['energy'],
        'danceability': json['danceability'],
        'valence': json['valence'],
        'previewUrl': json['preview_url'],
    };
}
export function BulkTrackResponseDtoToJSON(json) {
    return BulkTrackResponseDtoToJSONTyped(json, false);
}
export function BulkTrackResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'artist': value['artist'],
        'album': value['album'],
        'albumCover': value['albumCover'],
        'bpm': value['bpm'],
        'key': value['key'],
        'popularity': value['popularity'],
        'energy': value['energy'],
        'danceability': value['danceability'],
        'valence': value['valence'],
        'preview_url': value['previewUrl'],
    };
}
